// LIST
export const FETCH_SETTINGS = "app/Settings/FETCH_SETTINGS";
export const FETCH_SETTINGS_SUCCESS = "app/Settings/FETCH_SETTINGS_SUCCESS";
export const FETCH_SETTINGS_FAILURE = "app/Settings/FETCH_SETTINGS_FAILURE";

// ADD
export const SAVE_SETTINGS = "app/Settings/SAVE_SETTINGS";
export const SAVE_SETTINGS_SUCCESS = "app/Settings/SAVE_SETTINGS_SUCCESS";
export const SAVE_SETTINGS_FAILURE = "app/Settings/SAVE_SETTINGS_FAILURE";
